import * as Styled from './styled';

const LogoIcon: React.FC<{
  logoUrl?: string;
  name: string;
  height?: number;
  width?: number;
  style?: React.CSSProperties;
}> = ({ logoUrl, name, height = 14, width, style }) => {
  const size = width || height;
  return logoUrl ? (
    <Styled.LogoImage src={logoUrl} alt={name} height={height || size} width={width || size} style={style} />
  ) : (
    <Styled.LogoPlaceholder height={height || size} width={width || size} style={style}>
      {name.charAt(0).toUpperCase()}
    </Styled.LogoPlaceholder>
  );
};

export default LogoIcon;
